import { Configuration } from './generated'
import * as Endpoints from './generated/apis'
import { querystring } from './utils'
import { fetchWithAuth } from './utils/fetchWithAuth'

export class ApiService {
  config = this._generateConfig()

  general = new Endpoints.GeneralApi(this.config)
  user = new Endpoints.UserApi(this.config)
  application = new Endpoints.ApplicationApi(this.config)
  createApplication = new Endpoints.CreateApplicationApi(this.config)
  dictionary = new Endpoints.DictionaryApi(this.config)
  fns = new Endpoints.FnsApi(this.config)
  help = new Endpoints.HelpApi(this.config)
  mktu = new Endpoints.MktuApi(this.config)
  registries = new Endpoints.RegistriesApi(this.config)
  registrySearch = new Endpoints.RegistrySearchApi(this.config)
  trademarkRequest = new Endpoints.TrademarkRequestApi(this.config)
  userDocuments = new Endpoints.UserDocumentsApi(this.config)
  promoCodes = new Endpoints.PromoCodesApi(this.config)
  instruction = new Endpoints.InstructionsApi(this.config)
  faq = new Endpoints.FaqApi(this.config)
  partner = new Endpoints.PartnerApi(this.config)

  private _generateConfig() {
    return new Configuration({
      basePath: process.env.NEXT_PUBLIC_API_URL.slice(0, -8),
      headers: {
        Accept: 'application/json',
      },
      credentials: 'include',
      fetchApi: fetchWithAuth,
      queryParamsStringify: querystring,
    })
  }

  reloadConfig() {
    this.config.config = this._generateConfig()
  }
}
